import React from 'react';
import { Check, X, Minus } from 'lucide-react';

const CFG = {
  yes:         { bg: '#16A34A', icon: Check,  label: 'Confirmé',     title: 'Confirmé — cliquez pour cycler' },
  no:          { bg: '#EF4444', icon: X,      label: 'Refusé',      title: 'Refusé — cliquez pour cycler'    },
  pending:     { bg: '#FFFFFF', icon: null,   label: 'En attente',  title: 'En attente — cliquez pour cycler', border: '#D1D5DB' },
  not_invited: { bg: '#F3F4F6', icon: Minus,  label: 'Non invité',  title: 'Non invité — cliquez pour cycler', iconColor: '#9CA3AF' },
};

/**
 * Pastille de statut RSVP cliquable.
 * onClick() → cycle via useInvites.cycleStatus
 */
export default function StatusDot({ status = 'pending', onClick, size = 22, showLabel = false }) {
  const cfg   = CFG[status] ?? CFG.pending;
  const Icon  = cfg.icon;
  const color = cfg.iconColor ?? '#FFFFFF';

  return (
    <button
      onClick={(e) => { e.stopPropagation(); onClick?.(); }}
      title={cfg.title}
      style={{
        width:        size,
        height:       size,
        borderRadius: '50%',
        background:   cfg.bg,
        border:       `2px solid ${cfg.border ?? cfg.bg}`,
        display:      'inline-flex',
        alignItems:   'center',
        justifyContent: 'center',
        cursor:       'pointer',
        padding:      0,
        flexShrink:   0,
        transition:   'transform .1s',
        verticalAlign: 'middle',
      }}
      onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.15)'; }}
      onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)';    }}
    >
      {Icon && <Icon size={size * 0.52} color={color} strokeWidth={3} />}
    </button>
  );
}
